import { AxiosRequestConfig } from "axios";
import Helpers from "./Helpers";

export type ErrorLog = {
  consentId: string;
  userId: string;
  bankName: string;
  errorTime: string;
  consentStartTime: string;
  currentUri: string;
  message: string;
};

export type ErrorResult = {
  message: string;
  time: Date;
  data?: {
    bankName: string;
    sessionId: string;
    consentId: string;
    consentStartTime: string;
    timeUtcString: string;
    currentUri: string;
  };
};

export function PostErrorLog(sessionId: string, errorLog: ErrorLog) {
  let configPut: AxiosRequestConfig = {
    method: "post",
    url: `${process.env.REACT_APP_PUBLIC_API_BASE_URI}/portal/session/${sessionId}/error-log`,
    data: {
      userId: errorLog.userId,
      currentUri: errorLog.currentUri,
      errorMessage: errorLog.message,
      additionalInformation: `ConsentId: ${errorLog.consentId}
UserId: ${errorLog.userId}
BankName: ${errorLog.bankName}
ErrorTime: ${errorLog.errorTime}
ConsentStartTime: ${errorLog.consentStartTime}
CurrentUri: ${errorLog.currentUri}
Message: ${errorLog.message}
`,
    },
  };

  Helpers.CallApi(
    configPut,
    () => {
      // handle success - there's nothing we need to do here
    },
    () => {
      // handle error - we don't need to do anything here, if this blows up, there's nothing we can do about it
    }
  );
}
